const dataLists = {
  columnHeaders: {
    name: 'Name',
    defaultLocale: 'Default language',
    genericName: 'Name',
    creationDate: 'Created',
    updatingDate: 'Updated',
  },
};

export default dataLists;
